import { render, staticRenderFns } from "./ChartHome.vue?vue&type=template&id=04cd630c&"
import script from "./ChartHome.vue?vue&type=script&lang=js&"
export * from "./ChartHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports